import { createRoute,lazyRouteComponent } from '@tanstack/react-router'

import { profileRoute } from '.'

const PersonalData = lazyRouteComponent(() => import('../../pages/profile/personal-data'))

export const profileIndexRoute = createRoute({
  getParentRoute: () => profileRoute,
  path: '/',
  component: PersonalData,
})
